import { render, staticRenderFns } from "./frontFormComentario.vue?vue&type=template&id=36d5f16e&scoped=true&"
import script from "./frontFormComentario.vue?vue&type=script&lang=js&"
export * from "./frontFormComentario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d5f16e",
  null
  
)

export default component.exports